import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store/store';
import RouteConfig from './Routes/RouteConfig';
import './styles.css';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <div className="App">
          <RouteConfig />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
